/* ps-journey.js — journey + A/B capture. sessionStorage + one cookie. No network calls. */
(function () {
  'use strict';

  var KEY = 'ps_journey';
  var SID = 'ps_session_id';
  var CAP = 20;
  var UTM = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
  var store = null;
  try { store = window.sessionStorage; } catch (e) { store = null; }

  function get(k) { try { return store ? store.getItem(k) : null; } catch (e) { return null; } }
  function set(k, v) { try { if (store) store.setItem(k, v); } catch (e) { /* private mode */ } }

  function uuid() {
    try { if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID(); } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 3) | 8).toString(16);
    });
  }

  var here = window.location.pathname || '/';

  var sid = get(SID);
  if (!sid) { sid = uuid(); set(SID, sid); }

  /* journey */
  var j = null;
  try { j = JSON.parse(get(KEY) || 'null'); } catch (e) {}
  if (!j || typeof j !== 'object' || !j.landing) {
    var q = new URLSearchParams(window.location.search);
    var utm = {};
    UTM.forEach(function (k) { var v = q.get(k); if (v) utm[k] = v; });
    j = { landing: here, path: [], ts: new Date().toISOString(), utm: utm };
  }
  if (!Array.isArray(j.path)) j.path = [];
  if (j.path[j.path.length - 1] !== here) j.path.push(here);
  if (j.path.length > CAP) j.path = j.path.slice(-CAP);
  set(KEY, JSON.stringify(j));

  /* A/B: one cookie, "experiment=variant" pairs joined by ";" */
  var ab = {};
  var raw = document.cookie.match(/(?:^|;\s*)ps_ab=([^;]*)/);
  if (raw && raw[1]) decodeURIComponent(raw[1]).split(';').forEach(function (p) {
    var i = p.indexOf('=');
    if (i > 0) ab[p.slice(0, i).trim()] = p.slice(i + 1).trim();
  });
  var assigned = false;
  Array.prototype.forEach.call(document.querySelectorAll('[data-ps-experiment]'), function (el) {
    var id = (el.getAttribute('data-ps-experiment') || '').trim();
    if (!id) return;
    if (!ab[id]) { ab[id] = Math.random() < 0.5 ? 'A' : 'B'; assigned = true; }
    el.setAttribute('data-ps-variant', ab[id]);
  });
  var serial = Object.keys(ab).map(function (k) { return k + '=' + ab[k]; }).join(';');
  if (assigned) {
    document.cookie = 'ps_ab=' + encodeURIComponent(serial) + ';path=/;max-age=31536000;SameSite=Lax';
  }
  window.psAb = ab;
  try { document.documentElement.dataset.psAb = serial; } catch (e) {}

  /* fill the hidden [data-ps-journey] inputs */
  function fill() {
    var v = {
      landing: j.landing,
      path: j.path.join(' | '),
      converted_on: window.location.pathname || '/',
      ab: serial,
      session: sid
    };
    Array.prototype.forEach.call(document.querySelectorAll('[data-ps-journey]'), function (el) {
      var k = el.getAttribute('data-ps-journey');
      if (Object.prototype.hasOwnProperty.call(v, k)) el.value = v[k];
    });
  }
  fill();
  document.addEventListener('submit', fill, true);
})();